import { render, staticRenderFns } from "./YaoYue.vue?vue&type=template&id=105dc043&scoped=true&"
import script from "./YaoYue.vue?vue&type=script&lang=js&"
export * from "./YaoYue.vue?vue&type=script&lang=js&"
import style0 from "./YaoYue.vue?vue&type=style&index=0&id=105dc043&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105dc043",
  null
  
)

export default component.exports